module.exports = __webpack_public_path__ + "img/index-sport.c230f8e5.svg";